import { Layout, Result404 } from 'components';
import { ResultError } from 'components/errors';
import { ResultNoCompany } from 'components/errors/result-company';
import { MainFiltersProvider } from 'components/main-filters/main-filters.context';
import { AccountSettingsView } from 'features/account-settings';
import { AssignClientsView } from 'features/assigned-clients/routes/assign-clients';
import { LoginView } from 'features/auth';
import { ChangePassword } from 'features/auth/routes/change-password';
import OtpView from 'features/auth/routes/otp-view';
import { ResetView } from 'features/auth/routes/reset-password';
import { SignupPage } from 'features/auth/routes/signup';
import DashBoardView from 'features/Dashboard/routes/dashboard-view';
import { DocumentView } from 'features/document-report/routes/doucment-view';
import { UploadUniversalDocuments } from 'features/document-report/routes/universal-link';
import { UploadLinkDocuments } from 'features/document-report/routes/upload-link';
import { LegalDocumentsView } from 'features/legal-documents/routes/legal-documents';
import { ManagementReportView } from 'features/management-report/routes/management-report-view';
import { AddClientView } from 'features/new-clients/routes/add-clients';
import { ClientsListView } from 'features/new-clients/routes/new-clients';
import { ClientsDetailsView } from 'features/new-clients/routes/new-clients-details';
import { RoleView } from 'features/role-management/routes/role-list';
import { AdminUsersView, AdminUserUpdateView } from 'features/users';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';

import { AuthenticatedRoute } from './authenticated-route';
import { ROUTES } from './constants';
import { UnauthenticatedRoute } from './unauthenticated-route';
export const routerConfig: RouteObject[] = [
  {
    errorElement: <ResultError />,
    children: [
      {
        path: ROUTES.LOGIN,
        element: (
          <UnauthenticatedRoute>
            <LoginView />
          </UnauthenticatedRoute>
        ),
      },
      {
        path: ROUTES.SIGNUP,
        element: (
          <UnauthenticatedRoute>
            <SignupPage />
          </UnauthenticatedRoute>
        ),
      },

      {
        path: ROUTES.OTP,
        element: (
          // <UnauthenticatedRoute>
          <OtpView />
          // </UnauthenticatedRoute>
        ),
      },
      {
        path: ROUTES.RESET_PASSWORD,
        element: (
          // <UnauthenticatedRoute>
          <ChangePassword />
          // </UnauthenticatedRoute>
        ),
      },
      {
        path: ROUTES.DOCUMENT_LINK_UPLOAD,
        element: <UploadLinkDocuments />,
      },
      {
        path: ROUTES.DOCUMENT_UNIVERASL_DOCUMENT_UPLOAD,
        element: <UploadUniversalDocuments />,
      },
      {
        path: ROUTES.CHANGE_PASSWORD,
        element: <ResetView />,
      },
      {
        path: ROUTES.HOME,
        element: (
          <AuthenticatedRoute>
            <Layout />
          </AuthenticatedRoute>
        ),
        children: [
          {
            path: ROUTES.HOME,
            element: <Navigate to={ROUTES.DASHBOARD} replace />,
          },
          {
            path: ROUTES.ACCOUNT_SETTINGS,
            element: <AccountSettingsView />,
          },
          {
            path: ROUTES.MANAGEMENT_REPORT,
            element: (
              <MainFiltersProvider>
                <ManagementReportView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.DOCUMENT,
            element: (
              <MainFiltersProvider>
                <DocumentView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.DASHBOARD,
            element: (
              <MainFiltersProvider>
                <DashBoardView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.ASSIGNED,
            element: (
              <MainFiltersProvider>
                <AssignClientsView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.USERS_ADMIN,
            element: <AdminUsersView />,
            children: [
              {
                path: ROUTES.USERS_ADMIN_EDIT,
                element: <AdminUserUpdateView />,
              },
            ],
          },
          {
            path: ROUTES.CLIENTS,
            element: (
              <MainFiltersProvider>
                <ClientsListView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.CLIENTS_ADD,
            element: (
              <MainFiltersProvider>
                <AddClientView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.CLIENTS_DETAILS,
            element: (
              <MainFiltersProvider>
                <ClientsDetailsView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.LEGAL_DOCUMENT,
            element: (
              <MainFiltersProvider>
                <LegalDocumentsView />
              </MainFiltersProvider>
            ),
          },
          {
            path: ROUTES.ROLE_MANAGEMENT,
            element: (
              <MainFiltersProvider>
                <RoleView />
              </MainFiltersProvider>
            ),
          },
        ],
      },
      {
        path: ROUTES.NOT_FOUND,
        element: <Result404 />,
      },
      {
        path: ROUTES.NOT_FOUND_COMPANY,
        element: <ResultNoCompany />,
      },
    ],
  },
];

export const router = createBrowserRouter(routerConfig);
